import Image1 from '../../assets/portfolio_PT.jpg'
import Image2 from '../../assets/artifact1.png'
import Image3 from '../../assets/ppcover.jpg'
import Image4 from '../../assets/rmm2.png'
import Image5 from '../../assets/slender10-min.png'
import Image6 from '../../assets/wattsapp.png'
import TempImage from '../../assets/temp.jpg'

const data = [
    {
        id: 1,
        category: 'Graphics & Shaders',
        image: Image1,
        title: "Cornell Box Path Tracer (Graphics & Shaders)",
        desc: "This project is a basic path-tracing ray tracer inside of a Cornell box using C++. The ray tracer simulates the physics of light to generate a realistic image by tracing the paths of rays as they bounce through the scene, interacting with various objects and light sources. Last updated on 07/10/2024 ",
        demo: 'https://github.com/thomasfrer/Simple_Path-Ray_Tracer/releases/tag/release1.1',
        github: 'https://github.com/thomasfrer/Simple_Path-Ray_Tracer'
    },
    {
        id: 2,
        category: 'Game Development',
        image: Image2,
        title: "The Artifact (Game Development)",
        desc: "This is a small tag-type game I made in Unity as a mini project with a few goals in mind to accomplish; such as a first-to-third-person camera switcher, a minimap, and an AI with navigation. All of the assets used are free on the Unity marketplace or are from Mixamo.The goal of the game is to collect 5 artifacts without getting caught by the alien insects on the ship with you. Last updated on 25/11/2024",
        demo: 'https://tornas.itch.io/the-artifact',
        github: 'https://github.com/thomasfrer/Unity-Tag-Game'
    },
    {
        id: 3,
        category: 'Game Development',
        image: Image3,
        title: "Project Pack (Game Development)",
        desc: "This is a project I made in Unity where I was developing 7 different scenes in one project, giving the user a method of switching between those scenes and interacting with them. Last updated on 16/11/2024",
        demo: 'https://tornas.itch.io/project-pack',
        github: 'https://github.com/thomasfrer/Unity_Project_Pack'
    },
    {
        id: 4,
        category: 'Front-End Development', 
        image: Image4,
        title: "RateMyMovies (Front-End Development)",
        desc: "This project is a simple movie rating website that allows users to rate and discover movies and see the average rating of each movie. The website is still very much a work in progress and will continue to be improved over time adding new features such as a watchlist, the top rated site movies, and a community discussion tab. The website is a collaborative effort by me and my friend Jadon Burgardt, built using HTML, CSS, and JavaScript. A github repository is not planned to be publicly available. (Currently being worked on)",
        demo: 'https://ratemymovies.netlify.app/index.html',
        //github: "temp"
    },
    {
        id: 5,
        category: 'Game Development',
        image: Image5,
        title: "Slender ReAwakened (Game Development)",
        desc: "This is a medium-scale project that was made for a game jam heavily inspired by the original Slender. It was made in Unity 6 HDRP Beta and has many cool features such as dynamic lighting, blended player animations, dynamic AI reactivity, and more. This is another project that I made with Jadon Burgardt. Last updated on 04/12/2024",
        demo: 'https://tornas.itch.io/slender-reawakened',
        github: 'https://github.com/thomasfrer/Slender_ReAwakened'
    },
    {
        id: 6,
        category: 'Front-End Development',
        image: Image6,
        title: "WattsApp (Front-End Development)",
        desc: "WattsApp is a responsive front-end showcase website designed to promote an energy-saving app concept. It emphasizes clean UX/UI,  animations, and modern styling using HTML, CSS, and JavaScript. The site features multiple sections including team info, project background, interactive gallery modals, and dynamic visual effects. A github repository is not planned to be publicly available. Last updated on 22/04/2025",
        demo: 'https://wattsapp.netlify.app/',
        //github: "temp"
    },
    {
        id: 7,
        category: 'Back-End Development',
        image: TempImage,
        title: "Project 4 (Back-End Development)",
        desc: "Project in Progress...",
        //demo: "temp",
        //github: "temp"
    }
]

export default data